import { TrayIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Content = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <TrayIcon {...rest} size={Sizes[size]} color={fill} />;
};

Content.displayName = 'Content';
